import LoginLayout from "@/pages/Layout/LoginLayout.vue";

import Login from "@/pages/Login.vue";

export default [
    {
      path: '/',
      component: LoginLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: Login
        }
      ]
    }
  ];